"use client";
import React, { useEffect, useState } from "react";

interface ModalProps {
  onClose?: () => void;
  isOpen: boolean;
  modalType: string | null;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, modalType, onClose }) => {
    
    const [htmlContentRules, setHtmlContentRules] = useState("");
    const [htmlContentPolicy, setHtmlContentPolicy] = useState("");
    const [htmlContent, setHtmlContent] = useState("");

	const stopClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
	};
	useEffect(() => {
		fetch("/policy.html")		  
		  .then((response) => {
		    if (!response.ok) {
		      throw new Error(`HTTP error! status: ${response.status}`);
		    }
		    return response.text();
		  })
		  .then((data) => {
		    setHtmlContentPolicy(data);
		  });
		fetch("/rules.html")
		  .then((response) => {
		    if (!response.ok) {
		      throw new Error(`HTTP error! status: ${response.status}`);
		    }
		    return response.text();
		  })
		  .then((data) => {
		    setHtmlContentRules(data);
		  });
	}, []);

	useEffect(() => {
		if (modalType == "rules")
			setHtmlContent(htmlContentRules);
		else
			setHtmlContent(htmlContentPolicy);
	}, [modalType, isOpen]);

	if (!isOpen) return null;
	
    return (
        <div className="fixed inset-0 flex
                        items-center justify-center
                        bg-black bg-opacity-50 p-6" onClick={onClose}>
            <div className="bg-white rounded-lg
                            shadow-lg p-6 max-w-[1200px] max-h-full
                            w-5/6 relative my-4 overflow-scroll h-full" onClick={stopClose}>
                <button
                    className="absolute top-2 right-3 text-gray-500 hover:text-gray-700"
                    onClick={onClose}>
                    &#x2715; {/* Close button */}
                </button>
            	<div dangerouslySetInnerHTML={{ __html: htmlContent }} className="bg-white" />
            </div>
        </div>
    );
};